import { TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";

const filter = createFilterOptions();

function PitcherList(props) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [pitchers, setPitchers] = useState([]);
  const [selectedPitcher, setSelectedPitcher] = useState(props.initialValue);

  useEffect(() => {
    setSelectedPitcher(props.initialValue);
  }, [props.initialValue]);

  const requestData = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Game/Pitcher_GetList`;

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        const items = data.map((pitcher) => {
          const name = (pitcher.PitcherName || pitcher.pitcherName || "").trim();
          return { ...pitcher, PitcherName: name };
        });
        setPitchers(items);
      });
  }, []);

  useEffect(() => {
    requestData();
  }, [requestData]);

  const handleIdBookChange = useCallback(
    (newValue) => {
      props.setPitcherOnMem(newValue);
      setSelectedPitcher(newValue);
    },
    [props]
  );

  const insertPitcher = useCallback(
    (PitcherName) => {
      handleIdBookChange(PitcherName);
      axios
        .post(`${process.env.REACT_APP_API2_URL}/Game/Pitcher_Insert`, {
          PitcherName,
          IdUser: Number(userInfo.userId),
        })
        .then((response) => response.data)
        .then(() => requestData());
    },
    [requestData, userInfo, handleIdBookChange]
  );

  const printInputList = () => {
    return (
      <FormControl size="small" variant="outlined">
        <Autocomplete
          freeSolo
          label="Pitcher"
          id="demo-simple-select-placeholder-label"
          options={pitchers}
          renderOption={(option) => option.PitcherName}
          renderInput={(params) => (
            <TextField {...params} label="Pitcher" variant="outlined" />
          )}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === "string") {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }

            // Regular option
            return option.PitcherName;
          }}
          value={selectedPitcher}
          onChange={(event, newValue) => {
            if (typeof newValue === "string") {
              handleIdBookChange(event);
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              Swal.fire({
                title: "Confirm",
                text: "Add this Pitcher to the Pitcher List?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
              }).then((result) => {
                if (result.isConfirmed) {
                  insertPitcher(newValue.inputValue);
                } else {
                  handleIdBookChange("");
                }
              });
            } else {
              handleIdBookChange(newValue?.PitcherName);
            }
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            // Suggest the creation of a new value
            if (params.inputValue !== "") {
              filtered.push({
                inputValue: params.inputValue,
                PitcherName: `Add "${params.inputValue}"`,
              });
            }

            return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
        />
      </FormControl>
    );
  };

  if (props.isInput) {
    return printInputList();
  }

  return null;
}

PitcherList.propTypes = {
  initialValue: PropTypes.string,
  isInput: PropTypes.bool.isRequired,
  setPitcherOnMem: PropTypes.func.isRequired,
};

export default PitcherList;
